'use strict';
const angular = require('angular');

export default angular.module('wftOrderFormApp.datePicker', [])
  .directive('datePicker', function() {
    return {
      template: require('./datePicker.html'),
      translude: true,
      restrict: 'E',
      replace: true,
      scope: {
        name: '<',
        ngModel: '=',
        required: '<'
      },
      link: function (scope, element, attrs) {
        scope.options = {
          formatYear: 'yyyy',
          startingDay: 0,
          //minDate: new Date(),
          showWeeks: true
        };
        scope.format = 'MM/dd/yyyy';
        scope.opened = false;
        scope.open = function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          scope.opened = true;
        };
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directives/datePicker/datePicker.directive.js